<template>
  <v-card class="premium-dialog-card" style="width: 100%">
    <!-- Header -->
    <div class="premium-dialog-header">
      <div class="header-content">
        <v-icon large color="white" class="mr-3"
          >mdi-file-search-outline</v-icon
        >
        <div class="header-text-container">
          <h2 class="premium-dialog-title">Student Scholarship Preview</h2>
          <p class="premium-dialog-subtitle">
            Review applicant details, documents, and submit approval status
          </p>
        </div>
      </div>
      <v-btn icon dark class="close-btn" @click="closePrompt">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <!-- Content -->
    <v-card-text class="premium-dialog-content">
      <!-- Student Details Section -->
      <div class="premium-section-card student-main-card">
        <v-row align="center">
          <v-col
            cols="12"
            md="3"
            class="text-center d-flex flex-column align-center justify-center"
          >
            <div class="student-avatar-container">
              <v-img
                :src="records.StudentImagePath"
                class="student-avatar"
                height="160"
                width="160"
                contain
              ></v-img>
            </div>
            <div class="student-quick-id mt-3">
              <span class="id-label">Application No</span>
              <span class="id-value">{{ records.ApplicationNumber }}</span>
            </div>
          </v-col>
          <v-col cols="12" md="9">
            <div class="section-heading-wrapper">
              <v-icon color="#3a67b1" class="mr-2"
                >mdi-account-school-outline</v-icon
              >
              <h3 class="section-title">Student Details</h3>
            </div>

            <div class="details-grid mt-4">
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-card-account-details-outline</v-icon
                  >
                  Application Number
                </span>
                <span class="detail-value font-weight-bold">{{
                  records.ApplicationNumber
                }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-account-outline</v-icon
                  >
                  Name
                </span>
                <span class="detail-value highlight-value">{{
                  records.StudentName
                }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-gender-male-female</v-icon
                  >
                  Gender
                </span>
                <span class="detail-value">{{ records.Gender }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-school-outline</v-icon
                  >
                  School
                </span>
                <span class="detail-value">{{
                  records.StudentSchoolName
                }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-account-multiple-outline</v-icon
                  >
                  Parent Name
                </span>
                <span class="detail-value">{{
                  records.StudentParentName
                }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-phone-outline</v-icon
                  >
                  Parent Contact
                </span>
                <span class="detail-value">{{ records.ParentContact }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-tag-outline</v-icon
                  >
                  Category
                </span>
                <span class="detail-value">{{ records.Category }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#edbe38"
                    >mdi-handshake-outline</v-icon
                  >
                  Sponsor Name
                </span>
                <span class="detail-value">{{ records.SponserName }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#56bda3"
                    >mdi-currency-inr</v-icon
                  >
                  Annual Income
                </span>
                <span class="detail-value income-value"
                  >₹{{ records.AnnualIncome }}</span
                >
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#0097d7">mdi-school</v-icon>
                  Scholarship Type
                </span>
                <div class="detail-value">
                  <span
                    :style="{
                      backgroundColor:
                        records.StudentScholarshipTypeColor || '#3a67b1',
                    }"
                    class="premium-status-badge"
                  >
                    {{ records.StudentScholarshipTypeTxt }}
                  </span>
                </div>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-check-circle-outline</v-icon
                  >
                  Approval Status
                </span>
                <div class="detail-value">
                  <span
                    :style="{
                      backgroundColor:
                        records.StudentApprovalStatusColor || '#3a67b1',
                    }"
                    class="premium-status-badge"
                  >
                    {{ records.StudentApprovalStatusTxt }}
                  </span>
                </div>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-file-document-outline</v-icon
                  >
                  Application Status
                </span>
                <div class="detail-value">
                  <span
                    :style="{
                      backgroundColor: records.ReportStatusColor || '#3a67b1',
                    }"
                    class="premium-status-badge"
                  >
                    {{ records.ReportStatusTxt }}
                  </span>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>

      <!-- Bank Details & Mark Details Section -->
      <v-row>
        <v-col cols="12" md="6">
          <div class="premium-section-card height-100">
            <div class="section-heading-wrapper">
              <v-icon color="#3a67b1" class="mr-2">mdi-bank-outline</v-icon>
              <h3 class="section-title">Bank Details</h3>
            </div>
            <div class="details-grid two-cols mt-4">
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-account-outline</v-icon
                  >
                  Account Holder
                </span>
                <span class="detail-value">{{
                  records.AccountHolderName
                }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-numeric</v-icon
                  >
                  Account Number
                </span>
                <span class="detail-value account-number">{{
                  records.AccountNumber
                }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-bank-outline</v-icon
                  >
                  Bank Name
                </span>
                <span class="detail-value">{{ records.BankName }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-map-marker-outline</v-icon
                  >
                  Branch Name
                </span>
                <span class="detail-value">{{ records.BranchName }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-barcode</v-icon
                  >
                  IFSC Code
                </span>
                <span class="detail-value code-value">{{
                  records.IfscCode
                }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-shield-check-outline</v-icon
                  >
                  Account Status
                </span>
                <div class="detail-value">
                  <span
                    :style="{
                      backgroundColor:
                        records.AccountStatusTxtColor || '#3a67b1',
                    }"
                    class="premium-status-badge"
                  >
                    {{ records.AccountStatusTxt }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="6">
          <div class="premium-section-card height-100">
            <div class="section-heading-wrapper">
              <v-icon color="#3a67b1" class="mr-2"
                >mdi-chart-bell-curve-cumulative</v-icon
              >
              <h3 class="section-title">Mark & Student Details</h3>
            </div>
            <div class="details-grid single-col mt-4">
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-google-classroom</v-icon
                  >
                  Class
                </span>
                <span class="detail-value font-weight-bold"
                  >{{ records.ClassName }}th Std</span
                >
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#0097d7"
                    >mdi-percent</v-icon
                  >
                  Percentage
                </span>
                <span class="detail-value percentage-value font-weight-bold"
                  >{{ records.Percentage }}%</span
                >
              </div>
              <div class="detail-item">
                <span class="detail-label">
                  <v-icon small class="mr-1" color="#3a67b1"
                    >mdi-account-star-outline</v-icon
                  >
                  Student Type
                </span>
                <span class="detail-value">{{ records.StudentType }}</span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Transaction Details Section -->
      <div class="premium-section-card mt-4">
        <div class="section-heading-wrapper">
          <v-icon color="#3a67b1" class="mr-2">mdi-cash-register</v-icon>
          <h3 class="section-title">Transaction Details</h3>
        </div>
        <div class="premium-table-container mt-4">
          <v-simple-table class="premium-table">
            <thead>
              <tr>
                <th>Transaction Type</th>
                <th>Issued Date</th>
                <th>Issued Amount</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in records.ScholarshipIssued"
                :key="index"
              >
                <td class="font-weight-medium">
                  {{ item.TransactionTypeName }}
                </td>
                <td>{{ item.ScholarshipIssuedDate }}</td>
                <td class="amount-cell">
                  {{ item.ScholarshipIssuedAmount }} Rs
                </td>
                <td class="remarks-cell">
                  {{ item.ScholarshipIssuedRemarks }}
                </td>
              </tr>
              <tr
                v-if="
                  !records.ScholarshipIssued ||
                  records.ScholarshipIssued.length === 0
                "
              >
                <td colspan="4" class="text-center no-data">
                  No scholarship transaction details available
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>

      <!-- Attachments Section -->
      <div class="premium-section-card mt-4">
        <div class="section-heading-wrapper">
          <v-icon color="#3a67b1" class="mr-2">mdi-attachment-plus</v-icon>
          <h3 class="section-title">Attachments</h3>
        </div>
        <div v-viewer class="attachments-grid mt-4">
          <v-row>
            <!-- Income Proof -->
            <v-col cols="12" sm="6" md="3">
              <div class="attachment-card">
                <span class="attachment-title">Income Proof</span>
                <div class="attachment-preview-box">
                  <img
                    :src="records.IncomeProofImagePath"
                    class="attachment-img"
                  />
                </div>
                <div class="attachment-actions">
                  <a
                    :href="records.IncomeProofImagePath"
                    :download="records.IncomeProofImagePath"
                    target="_blank"
                    class="download-link"
                  >
                    <v-icon size="16" class="mr-1">mdi-download</v-icon>
                    Download
                  </a>
                </div>
              </div>
            </v-col>

            <!-- Passbook -->
            <v-col cols="12" sm="6" md="3">
              <div class="attachment-card">
                <span class="attachment-title">Passbook</span>
                <div class="attachment-preview-box">
                  <img
                    :src="records.PassbookImagePath"
                    class="attachment-img"
                  />
                </div>
                <div class="attachment-actions">
                  <a
                    :href="records.PassbookImagePath"
                    :download="records.PassbookImagePath"
                    target="_blank"
                    class="download-link"
                  >
                    <v-icon size="16" class="mr-1">mdi-download</v-icon>
                    Download
                  </a>
                </div>
              </div>
            </v-col>

            <!-- Marksheet -->
            <v-col cols="12" sm="6" md="3">
              <div class="attachment-card">
                <span class="attachment-title">Marksheet</span>
                <div class="attachment-preview-box">
                  <img
                    :src="records.MarksheetImagePath"
                    class="attachment-img"
                  />
                </div>
                <div class="attachment-actions">
                  <a
                    :href="records.MarksheetImagePath"
                    :download="records.MarksheetImagePath"
                    target="_blank"
                    class="download-link"
                  >
                    <v-icon size="16" class="mr-1">mdi-download</v-icon>
                    Download
                  </a>
                </div>
              </div>
            </v-col>

            <!-- Special Category Documents -->
            <v-col cols="12" sm="6" md="3">
              <div class="attachment-card">
                <span class="attachment-title">Special Category Docs</span>
                <div class="attachment-preview-box">
                  <img
                    :src="records.SpecialCategoryDocumentImagePath"
                    class="attachment-img"
                  />
                </div>
                <div class="attachment-actions">
                  <a
                    :href="records.SpecialCategoryDocumentImagePath"
                    :download="records.SpecialCategoryDocumentImagePath"
                    target="_blank"
                    class="download-link"
                  >
                    <v-icon size="16" class="mr-1">mdi-download</v-icon>
                    Download
                  </a>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- Description Block -->
      <div
        class="premium-section-card mt-4"
        v-if="records.DescriptionTxt != ''"
      >
        <div class="section-heading-wrapper">
          <v-icon color="#3a67b1" class="mr-2">mdi-comment-text-outline</v-icon>
          <h3 class="section-title">Description</h3>
        </div>
        <div
          class="existing-desc-box mt-3"
          v-html="records.DescriptionTxt"
        ></div>
      </div>

      <!-- Input Description Block -->
      <div v-if="AdminFlag" class="premium-section-card mt-4">
        <div class="section-heading-wrapper">
          <v-icon color="#3a67b1" class="mr-2">mdi-pencil-box-outline</v-icon>
          <h3 class="section-title required-field">Description</h3>
        </div>
        <div class="mt-4">
          <v-textarea
            outlined
            v-model="Description"
            :rules="DescriptionRules"
            name="input-7-4"
            label="Description"
            class="premium-textarea"
            rows="3"
          ></v-textarea>
        </div>
      </div>

      <!-- Action Footer -->
      <div class="premium-dialog-footer mt-5">
        <div class="action-buttons-container">
          <v-btn
            v-if="AdminFlag"
            @click.prevent="submitForm(1)"
            :loading="ScholarshipLoadingFlag"
            class="action-btn btn-approve-scholarship"
          >
            <v-icon left>mdi-check-decagram</v-icon>
            Approve for scholarship
          </v-btn>
          <v-btn
            v-if="AdminFlag"
            @click.prevent="submitForm(2)"
            :loading="EmpowerHerLoadingFlag"
            class="action-btn btn-approve-empower"
          >
            <v-icon left>mdi-gender-female</v-icon>
            Approve for Empower her
          </v-btn>
          <v-btn
            v-if="AdminFlag"
            @click.prevent="submitForm(3)"
            :loading="RejectLoadingFlag"
            class="action-btn btn-reject"
          >
            <v-icon left>mdi-close-circle-outline</v-icon>
            Rejected
          </v-btn>
          <v-btn @click.prevent="closePrompt" class="action-btn btn-close">
            <v-icon left>mdi-close-circle-outline</v-icon>
            Cancel
          </v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  components: {},
  props: {
    pageTitle: {
      type: String,
    },
    recordData: {
      required: true,
    },
  },
  data() {
    return {
      valid1: false,
      valid2: false,
      ProgressLoadingFlag: false,
      submitFlag: false,
      LoadingFlag: false,

      ResultFlag: false,
      records: [],
      Description: "",
      DescriptionRules: [(v) => !!v || "Description is required"],

      ScholarshipLoadingFlag: false,
      RejectLoadingFlag: false,
      EmpowerHerLoadingFlag: false,

      ProgessStart: 0,
      flag: false,
      LoadingFlag: false,
      OverlayLoadingFlag: false,

      SuccessMessageTxtFlag: 0,
      SuccessMessageTxt: "",

      ErrorMessageTxtFlag: 0,
      ErrorMessageTxt: "",

      CardContent: [],
      PageInfo: {},
      RoleId: "",
      AdminFlag: false,
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        this.RoleId = RoleId;
        console.log("RoleId=" + RoleId);
        this.AdminFlag =
          RoleId == 1 || RoleId == 2 || RoleId == 4 ? true : false;
        this.pageData();
      }
    },
  },

  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidePreviewRecordPrompt", this.ResultFlag);
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "student_scholarship",
        Action: "report_1",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getStudentDetails();
    },
    getStudentDetails() {
      console.log(" getStudentDetails is called");

      var StudentId = this.recordData.StudentId;
      StudentId = StudentId == (null || undefined) ? "" : StudentId;
      console.log("StudentId=" + StudentId);

      if (StudentId != "") {
        var upload = {
          UserInterface: 2,
          Student: StudentId,
        };
        console.log({ upload });

        this.LoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/student/show";
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            if (flag == 1) {
              thisIns.records = records;
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "";
        if (SeniorLifeMemberPlan == "") {
          message += "senior life member plan code should not be empty.";
        }
        this.sweetAlert("error", message, false);
      }
    },
    submitForm(Status) {
      console.log("submitForm called");

      console.log({ Status });

      var tr = this.recordData;
      console.log("tr = " + JSON.stringify(tr));

      if (Status > 0) {
        switch (Status) {
          case 1:
            this.ScholarshipLoadingFlag = true;
            break;

          case 2:
            this.EmpowerHerLoadingFlag = true;
            break;

          case 3:
            this.RejectLoadingFlag = true;
            break;

          default:
            break;
        }

        this.LoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/student/update-approval-status";
        var upload = {
          UserInterface: Status,
          Student: tr.StudentId,
          Description: this.Description,
          ApplicationNumber: tr.ApplicationNumber,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;
        this.ResultFlag = false;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.ResultFlag = true;
              thisIns.sweetAlert("success", output, false);
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style scoped>
/* Card & Dialog Outer Styling */
.premium-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 12px 30px rgba(10, 15, 41, 0.15) !important;
  border: 1px solid rgba(58, 103, 177, 0.1) !important;
  background-color: #ffffff !important;
}

/* Header styling */
.premium-dialog-header {
  background: linear-gradient(135deg, #3a67b1 0%, #2a4c84 100%);
  padding: 24px 32px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #0097d7;
}

.premium-dialog-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(
    circle at 10% 20%,
    rgba(255, 255, 255, 0.05) 0%,
    transparent 60%
  );
  pointer-events: none;
}

.header-content {
  display: flex;
  align-items: center;
}

.premium-dialog-title {
  color: #ffffff !important;
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: 0.5px;
}

.premium-dialog-subtitle {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 0.85rem;
  margin: 4px 0 0 0;
}

.close-btn {
  background-color: rgba(255, 255, 255, 0.1) !important;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.25) !important;
  transform: rotate(90deg);
}

/* Content Container */
.premium-dialog-content {
  padding: 32px !important;
  background-color: #fcfdfe !important;
}

/* Custom Card Container for Sections */
.premium-section-card {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid rgba(58, 103, 177, 0.08);
  padding: 28px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(10, 15, 41, 0.03);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

/* Unique background pattern - modern premium geometric line grid */
.premium-section-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(
      rgba(58, 103, 177, 0.02) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(58, 103, 177, 0.02) 1px, transparent 1px);
  background-size: 24px 24px;
  pointer-events: none;
  opacity: 0.8;
  z-index: 0;
}

/* Ensure card content sits above the pattern */
.premium-section-card > * {
  position: relative;
  z-index: 1;
}

/* Accent element inside the card for visual depth */
.premium-section-card::after {
  content: "";
  position: absolute;
  top: -50px;
  right: -50px;
  width: 200px;
  height: 200px;
  background: radial-gradient(
    circle,
    rgba(0, 151, 215, 0.04) 0%,
    transparent 70%
  );
  pointer-events: none;
  border-radius: 50%;
  z-index: 0;
}

.premium-section-card:hover {
  box-shadow: 0 6px 24px rgba(10, 15, 41, 0.06);
  border-color: rgba(58, 103, 177, 0.2);
}

.student-main-card {
  border-left: 5px solid #3a67b1;
  background: linear-gradient(
    135deg,
    #ffffff 0%,
    rgba(58, 103, 177, 0.01) 100%
  );
}

.student-main-card::after {
  content: "";
  position: absolute;
  bottom: -60px;
  right: -60px;
  width: 240px;
  height: 240px;
  background: radial-gradient(
    circle,
    rgba(58, 103, 177, 0.05) 0%,
    transparent 70%
  );
  pointer-events: none;
  border-radius: 50%;
  z-index: 0;
}

/* Headings within cards */
.section-heading-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  padding-bottom: 16px;
  margin-bottom: 24px;
}

/* Bottom separator line */
.section-heading-wrapper::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: rgba(65, 64, 66, 0.06);
}

/* Premium gradient accent bar on the heading line */
.section-heading-wrapper::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 80px;
  height: 2px;
  background: linear-gradient(90deg, #3a67b1 0%, #0097d7 100%);
  z-index: 1;
}

.section-heading-wrapper i {
  background-color: rgba(58, 103, 177, 0.08) !important;
  color: #3a67b1 !important;
  padding: 10px !important;
  border-radius: 10px !important;
  font-size: 1.25rem !important;
  margin-right: 14px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: inset 0 1px 3px rgba(58, 103, 177, 0.1);
  transition: all 0.3s ease !important;
}

.premium-section-card:hover .section-heading-wrapper i {
  background-color: #3a67b1 !important;
  color: #ffffff !important;
  transform: scale(1.08) rotate(3deg);
  box-shadow: 0 4px 12px rgba(58, 103, 177, 0.2);
}

.section-title {
  font-size: 1.15rem;
  font-weight: 750;
  color: #0a0f29 !important;
  margin: 0 !important;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.required-field::after {
  content: " *";
  color: #fa1705;
}

/* Details Grid Layout */
.details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
}

.details-grid.two-cols {
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
}

.details-grid.single-col {
  grid-template-columns: 1fr;
}

.detail-item {
  display: flex;
  flex-direction: column;
  padding: 10px 14px;
  background: linear-gradient(
    135deg,
    #ffffff 0%,
    rgba(58, 103, 177, 0.03) 100%
  );
  border-radius: 10px;
  border: 1px solid rgba(58, 103, 177, 0.08);
  box-shadow: 0 2px 6px rgba(10, 15, 41, 0.01);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.detail-item:hover {
  transform: translateY(-2px);
  border-color: rgba(0, 151, 215, 0.3);
  box-shadow: 0 4px 12px rgba(0, 151, 215, 0.08);
  background: linear-gradient(135deg, #ffffff 0%, rgba(0, 151, 215, 0.05) 100%);
}

.detail-item:hover .detail-label i {
  transform: scale(1.1);
  color: #0097d7 !important;
}

.detail-label {
  font-size: 0.72rem;
  text-transform: uppercase;
  color: #414042;
  font-weight: 700;
  letter-spacing: 0.7px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
}

.detail-label i {
  transition: all 0.2s ease;
}

.detail-value {
  font-size: 0.95rem;
  color: #0a0f29;
  font-weight: 500;
  word-break: break-word;
}

.detail-value.highlight-value {
  color: #3a67b1;
  font-weight: 700;
  font-size: 1.05rem;
}

.detail-value.income-value {
  color: #56bda3;
  font-weight: 700;
}

.detail-value.percentage-value {
  color: #0097d7;
  font-size: 1.2rem;
}

.detail-value.account-number {
  font-family: monospace;
  font-size: 1rem;
  letter-spacing: 1px;
}

.detail-value.code-value {
  font-family: monospace;
  font-size: 1rem;
}

/* Avatar container */
.student-avatar-container {
  background: #ffffff;
  padding: 8px;
  border-radius: 16px;
  border: 2px solid rgba(58, 103, 177, 0.15);
  box-shadow: 0 8px 24px rgba(10, 15, 41, 0.06);
  display: inline-block;
  position: relative;
  transition: all 0.3s ease;
}

.student-avatar-container:hover {
  border-color: #0097d7;
  transform: scale(1.02);
  box-shadow: 0 12px 30px rgba(0, 151, 215, 0.12);
}

.student-avatar {
  border-radius: 10px;
}

.student-quick-id {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.student-quick-id .id-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  color: #414042;
  font-weight: 600;
}

.student-quick-id .id-value {
  font-size: 0.9rem;
  font-weight: 700;
  color: #3a67b1;
}

/* Premium Badges */
.premium-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 6px;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Premium Simple Table */
.premium-table-container {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(65, 64, 66, 0.1);
}

.premium-table {
  width: 100%;
}

.premium-table table {
  border-collapse: collapse;
}

.premium-table th {
  background-color: #3a67b1 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 0.85rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 12px 16px !important;
  border-bottom: none !important;
}

.premium-table td {
  padding: 12px 16px !important;
  font-size: 0.9rem !important;
  color: #414042 !important;
  border-bottom: 1px solid rgba(65, 64, 66, 0.06) !important;
}

.premium-table tbody tr:nth-of-type(even) {
  background-color: rgba(58, 103, 177, 0.02);
}

.premium-table tbody tr:hover {
  background-color: rgba(58, 103, 177, 0.05) !important;
  transition: background-color 0.2s ease;
}

.premium-table .amount-cell {
  font-weight: 700;
  color: #3a67b1;
}

.premium-table .remarks-cell {
  color: #414042;
  font-style: italic;
}

.premium-table .no-data {
  color: #414042;
  opacity: 0.6;
  font-style: italic;
  padding: 24px !important;
}

/* Attachments */
.attachments-grid {
  width: 100%;
}

.attachment-card {
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid rgba(65, 64, 66, 0.1);
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease;
}

.attachment-card:hover {
  border-color: #0097d7;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 151, 215, 0.1);
}

.attachment-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: #0a0f29;
  text-align: center;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.attachment-preview-box {
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(10, 15, 41, 0.02);
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid rgba(65, 64, 66, 0.05);
}

.attachment-img {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  cursor: zoom-in;
  transition: transform 0.3s ease;
}

.attachment-img:hover {
  transform: scale(1.05);
}

.attachment-actions {
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.download-link {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #3a67b1 !important;
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 6px 12px;
  background-color: rgba(58, 103, 177, 0.06);
  border-radius: 6px;
  transition: all 0.2s ease;
}

.download-link:hover {
  background-color: #3a67b1;
  color: #ffffff !important;
}

.download-link:hover i {
  color: #ffffff !important;
}

/* Existing Description text block */
.existing-desc-box {
  background-color: rgba(0, 151, 215, 0.03);
  border-left: 3px solid #0097d7;
  padding: 16px;
  border-radius: 0 8px 8px 0;
  font-size: 0.95rem;
  color: #414042;
  line-height: 1.6;
}

/* Premium Textarea styling */
.premium-textarea ::v-deep .v-input__control {
  border-radius: 8px !important;
}

.premium-textarea ::v-deep .v-input__slot {
  background-color: #ffffff !important;
  border-width: 1px !important;
  transition: all 0.3s ease !important;
}

.premium-textarea ::v-deep .v-input__slot:hover {
  border-color: #3a67b1 !important;
}

.premium-textarea ::v-deep .v-input--is-focused .v-input__slot {
  border-color: #0097d7 !important;
  box-shadow: 0 0 0 3px rgba(0, 151, 215, 0.15) !important;
}

/* Dialog Footer */
.premium-dialog-footer {
  border-top: 1px solid rgba(65, 64, 66, 0.1);
  padding: 24px 0 0 0;
  background-color: transparent;
}

.action-buttons-container {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 16px;
}

/* Premium Buttons */
.action-btn {
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-size: 0.9rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  height: auto !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease !important;
}

.action-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15) !important;
}

/* Approve for Scholarship (Success style: Seafoam) */
.btn-approve-scholarship {
  background-color: #56bda3 !important;
  color: #ffffff !important;
}

.btn-approve-scholarship:hover {
  background-color: #45ab91 !important;
}

/* Approve for Empower Her (Secondary style: Aqua) */
.btn-approve-empower {
  background-color: #0097d7 !important;
  color: #ffffff !important;
}

.btn-approve-empower:hover {
  background-color: #0081b8 !important;
}

/* Reject Applicant (Danger style: Red) */
.btn-reject {
  background-color: #fa1705 !important;
  color: #ffffff !important;
}

.btn-reject:hover {
  background-color: #d11202 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .premium-dialog-header {
    padding: 16px 20px;
  }
  .premium-dialog-content {
    padding: 20px !important;
  }
  .action-buttons-container {
    justify-content: center;
    width: 100%;
  }
  .action-btn {
    width: 100%;
  }
}
</style>
